import axios from "axios";

export class keycloakRest {

    refreshToken(): Promise<any> {
        let config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        }
        let data = {
            grant_type: 'refresh_token',
            client_id: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
            refresh_token: localStorage.getItem('refreshToken'),
        }

        return axios.post(`${process.env.VUE_APP_KEYCLOAK_URL}realms/${process.env.VUE_APP_KEYCLOAK_REALM}/protocol/openid-connect/token`, data, config)
        .then((response: any) => response.data);
    }

    logoutSession(): Promise<any> {
        let config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        }
        let data = {
            client_id: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
            grant_type: 'refresh_token',
            refresh_token: localStorage.getItem('refreshToken'),
        }

        return axios.post(`${process.env.VUE_APP_KEYCLOAK_URL}realms/${process.env.VUE_APP_KEYCLOAK_REALM}/protocol/openid-connect/logout`, data, config).then((response: any) => response.data);
    }
}